import React, { PureComponent, Fragment } from 'react';

import { numberFormat } from '~/core/scripts/utils';
import { is768Query } from '~/core/scripts/mediaquery-helper';
import Icon from '~/core/scripts/components/Icon';
import PartyBars from '~/scripts/PartyBars';
import RankingList from '~/scripts/RankingList';
import RankingListExpandButton from '~/scripts/RankingList/ExpandButton';

const isSmallScreen = !is768Query();

function getRotation(change) {
  if (!change) {
    return 0;
  }

  return change < 0 ? 45 : -45;
}

const showComparison = false; //baseconfig.app.has2014Data;

class DetailView extends PureComponent {
  state = {
    isExpanded: isSmallScreen
  }

  constructor() {
    super();

    const wrapper = document.querySelector('.electionmap-wrapper');

    this.wrapperBounds = wrapper.getBoundingClientRect();
    this.maxHeight = isSmallScreen ? window.innerHeight * 0.6 : (this.wrapperBounds.height * 0.9) - 140;
  }

  componentDidMount() {
    this.canvas.width = this.wrapperBounds.width;
    this.canvas.height = this.wrapperBounds.height;
    this.ctx = this.canvas.getContext('2d');

    this.updateCanvas();
  }

  componentDidUpdate() {
    if (!this.props.pos) {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      return false;
    }
    this.updateCanvas();
  }

  updateCanvas() {
    if (!is768Query()) {
      return false;
    }
    const { x, y } = this.props.pos;

    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.strokeStyle = '#eee';
    this.ctx.beginPath();
    this.ctx.moveTo(x, y);
    this.ctx.lineTo(window.innerWidth - 335, 110);
    this.ctx.stroke();

    this.ctx.beginPath();
    this.ctx.strokeStyle = 'none';
    this.ctx.fillStyle = '#eee';
    this.ctx.arc(x, y, 2, 0, 2 * Math.PI);
    this.ctx.fill();
  }

  onToggleExpand() {
    this.setState(prevState => ({
      isExpanded: !prevState.isExpanded
    }));
  }

  getSubtitle() {
    const { data } = this.props;
    const hasAmtProperty = typeof data.Amtsgemeinde !== 'undefined';

    if (hasAmtProperty && data.Amtsgemeinde === '1') {
      return <span className="light">(Amt für {data.Wahlgebiet_Desc})</span>;
    }

    if (data.Briefwahl === '1') {
      return <span className="light">(übernimmt Briefwahl für andere Gemeinden)</span>;
    }

    if (data.Briefwahl === '2') {
      return <span className="light">(Briefwähler von anderer Gemeinde ausgezählt)</span>;
    }
  }

  render() {
    const { isExpanded } = this.state;
    const { data, onClose } = this.props;
    const endIndex = isExpanded ? data.partyItems.length : 6;
    const subtitleExtra = this.getSubtitle();

    return (
      <Fragment>
        <div className="detailview">
          <div className="detailview__close btn close" onClick={onClose}>
            <Icon type="close" />
          </div>
          <div className="detailview__inner" style={{ maxHeight: `${this.maxHeight}px` }}>
            <div className="detailview__header">
              <div className="detailview__title">{data.Wahlgebiet_Name}</div>
              <div className="detailview__subtitle">Wahlkreis {data.Wahlgebiet2_Name}</div>
              <div className="detailview__subtitle">
                {data.Wahlgebiet_Name3} {subtitleExtra}
              </div>
            </div>
            <PartyBars showComparison={showComparison} items={data.partyItems} areaId={data.Wahlgebiet_ID} />

            <div className="detailview__content">
              <div className="detailview__section detailview__turnout">
                <div className="detailview__section-title">Wahlbeteiligung</div>

                <div className="detailview__turnout-values">
                  {showComparison && (
                    <div className="detailview__turnout-arrow" style={{ transform: `rotate(${getRotation(data.turnout - data.turnoutComp)}deg)` }}>
                      <Icon type="arrow-bold" />
                    </div>
                  )}
                  <div className="detailview__turnout-current"><strong>2019</strong> {numberFormat(data.turnout, 1)} %</div>
                  {showComparison && <div className="detailview__turnout-comp"><strong>2014</strong> {numberFormat(data.turnoutComp, 1)} %</div>}
                </div>

              </div>
              <div className="detailview__section detailview__ranking">
                <RankingList
                  data={data.partyItems.slice(0, endIndex)}
                  showVotes
                  showComparison={showComparison}
                />
              </div>
            </div>
           {!isSmallScreen && (
             <div className="detailview__footer">
              <RankingListExpandButton
                isExpanded={isExpanded}
                onClick={() => this.onToggleExpand()}
              />
            </div>
           )}
          </div>
        </div>
        <canvas className="detailcanvas" ref={ref => { this.canvas = ref; }} />
      </Fragment>
    );
  }
}

export default DetailView;
